<!-- 发布状态详情列表 -->
<template>
  <el-dialog width="960px" title="发布状态" :visible.sync="releaseStatusVisible" showClose append-to-body center>
    <cs-table
      ref="singleTable"
      :tableCols="tableCols"
      :tableData="tableData"
      :paginationOption="paginationOption"
      @current-change="currentPageHandler"
      @size-change="sizeChangeHandler"
      :showPagination="true"
    >
      <template slot-scope="scope" slot="pushTime">
        <span v-if="scope.row.pushTime">{{scope.row.pushTime|timeFormat}}</span>
        <span v-else>--</span>
        </template>
    </cs-table>
    <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="releaseStatusVisible = false">关 闭</el-button>
      </span>
  </el-dialog>
</template>
<script>
import { pushFlag } from '@/resource/api/index'
export default {
  name: 'ReleaseStatus',
  props: ['id'],
  data () {
    return {
      form: {
        limit: this.$store.state.pageLimit,
        offset: 1,
        companyId: this.$store.state.router.companyId
      },
      nameLabel: '节目名称',
      releaseStatusVisible: false,
      tableData: [],
      paginationOption: {
        'page-size': this.$store.state.pageLimit
      }
    }
  },
  computed: {
    tableCols () {
      return [
        { prop: 'resourceName', label: this.nameLabel },
        {
          prop: 'pushFlag',
          label: '发布状态',
          formatter: function (row, column) {
            let stateText = ''
            switch (row.pushFlag) {
              case 0:
                stateText = '待发布'
                break
              case 1:
                stateText = '发布中'
                break
              case 2:
                stateText = '发布失败'
                break
              case 3:
                stateText = '已发布'
                break
            }
            return stateText
          }
        },
        { prop: 'retryTimes', label: '重试次数' },
        { prop: 'state', label: '消息信息' },
        { prop: 'pushTime', label: '发布时间', type: 'slot' }
      ]
    }
  },
  methods: {
    open () {
      this.nameLabel = '作品名称'
      if (process.env.VUE_APP_NODE_ENV == 'CP') {
        this.nameLabel = '节目名称'
      } else {
        this.nameLabel = '作品名称'
      }
      this.form.id = this.id
      this.init(this.form)
    },
    init (data) {
      pushFlag(data).then((res) => {
        if (res.code == '1') {
          this.tableData = res.results
          this.paginationOption = {
            ...this.paginationOption,
            'current-page': this.form.offset,
            total: parseInt(res.total)
          }
          this.releaseStatusVisible = true // 打开弹出框
        }
      })
    },
    sizeChangeHandler (val) {
      this.form.limit = val
      this.form.offset = 1
      this.init(this.form)
    },
    currentPageHandler (val) {
      this.form.offset = val
      this.init(this.form)
    }
  }
}
</script>
<style scoped>

</style>
